import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  userData: {},
  userPermissions: {},
};

export const userSlice = createSlice({
  name: "DreamsAdminUser",
  initialState,
  reducers: {
    setUserData: (state, action) => {
      state.userData = action.payload;
    },
    setUserPermission: (state, action) => {
      state.userPermissions = action.payload;
    },
  }
});



export const { setUserData, setUserPermission } = userSlice.actions;
